import template from './item.template.html';
import './item.scss';
import './item-list/item-list.scss';

export default {
  template,
  bindings: {
    id: '<?',
    name: '<?',
    image: '<',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/item/item.component.js